import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Section 8 — Final CTA. */
export const FinalCTASection = () => {
  return (
    <section className="max-w-5xl mx-auto px-6 py-20" data-testid="final-cta-section">
      <div className="rounded-3xl border border-white/10 bg-[#0A101D]/60 p-12 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#5C9DFF]/10 to-[#B58BFF]/10" />
        <div className="relative">
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mb-4">Build a Career Recruiters Can Trust.</h2>
          <Link to="/register" data-testid="final-cta-btn" className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white font-semibold px-8 py-4 rounded-xl shadow-[0_0_30px_rgba(92,157,255,0.4)] transition-all hover:-translate-y-0.5">
            Start Free <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
